const headRowsFreq = {
  name: 'Frequency',
  month: 'Interval'
};

export default headRowsFreq;
